/* eslint-disable */
import { Button, Form, Input, Modal, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../../contexts/UserContext/UserContext";
import { useToast } from "../../../../contexts/ToastContext";
import apiClient from "../../../../helpers/apiClient";

const SingleRefundModal = ({ refetch, refundItem, closeSingleRefundModal, closeParentModal, resDetails }) => {
    const { t } = useTranslation("reservations");
    const toast = useToast();
    const { state } = useUser();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue(refundItem);
    }, [refundItem]);
    const onFinish = async (values) => {
        try {
            setLoading(true);
            console.log(values);

            const res = await apiClient.post("/api/payment/refund-payment", values, {
                headers: {
                    "company-id": state?.user?.companyId,
                },
            });
            if (res?.data?.success) {
                console.log(res.data.data);
                const updatePayload = {
                    refunds: [
                        ...(resDetails?.refunds || []),
                        {
                            ...res.data.data,
                            description: values.description,
                        },
                    ],
                    invoice: [
                        ...(resDetails?.invoice || []).filter((i) => i.paymentIntentId !== values.paymentIntentId),
                        {
                            ...(resDetails?.invoice || []).find((i) => i.paymentIntentId === values.paymentIntentId),
                            refunded: true,
                        },
                    ],
                    extraCharge: [
                        ...(resDetails?.extraCharge || []).filter(
                            (chrg) => chrg.paymentIntentId !== values.paymentIntentId,
                        ),
                        {
                            ...resDetails?.extraCharge.find((chrg) => chrg.paymentIntentId === values.paymentIntentId),
                            refunded: true,
                        },
                    ],
                };
                const updateRes = await apiClient.patch(
                    `/api/${resDetails.flag ? "reservation" : "past-reservation"}/${resDetails.id}`,
                    updatePayload,
                );
                if (updateRes?.data?.success) {
                    toast.success({ message: t("payment.refundSuccess") });
                }
            }

            refetch();
            form.resetFields();
            closeParentModal();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(error?.response?.data || error);
            toast.error({ message: t("payment.refundFailed") });
        }
    };
    const onReset = () => {
        form.resetFields();

        closeSingleRefundModal();
    };

    return (
        <Modal
            open={!!refundItem}
            onCancel={closeSingleRefundModal}
            maskClosable={false}
            onOk={form.submit}
            title="Refund Payment"
            centered
            footer={null}>
            <p className="w-full pb-10">
                Refunds take 5-10 days to appear on a customer's statement. Stripe's fees for the original payment won't
                be refunded, but there are no additional fees for processing refunds.
            </p>
            <Form initialValues={refundItem} form={form} onFinish={onFinish} onReset={onReset} layout="vertical">
                <Form.Item name="paymentIntentId" label="paymentIntentId" hidden>
                    <Input />
                </Form.Item>
                <Form.Item name="amount" label="Amount">
                    <Input disabled />
                </Form.Item>
                <Form.Item name="reason" label="Reason">
                    <Input />
                </Form.Item>
                <div className="w-full flex justify-end items-center gap-2">
                    <Button htmlType="reset" variant="outlined" color="danger" disabled={loading}>
                        Cancel
                    </Button>
                    <Button htmlType="submit" variant="solid" type="primary" loading={loading}>
                        Refund
                    </Button>
                </div>
            </Form>

            {/* <div
            style={{
                padding: '20px',
                width: '400px',
                position: 'relative',
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    cursor: 'pointer',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: 'black',
                    marginRight: '6px',
                }}
                className='close'
                onClick={() => closeSingleRefundModal()}
            >
                &times;
            </span>

            <div
                style={{
                    padding: '20px',
                    borderRadius: '8px',
                    border: '1px solid #a1a1a1',
                    marginBottom: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    marginTop: '20px',
                }}
            >
                <div
                    style={{
                        color: '#202020',
                        fontFamily: 'Poppins',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: 'normal',
                    }}
                >
                    Refund Payment
                </div>
                <div
                    style={{
                        color: '#707070',
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                    }}
                >
                    Refunds take 5-10 days to appear on a customer's statement. Stripe's
                    fees for the original payment won't be refunded, but there are no
                    additional fees for processing refunds.
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '20px',
                    }}
                >
                    <h1
                        style={{
                            color: '#202020',
                            fontFamily: 'Poppins',
                            fontSize: '12px',
                            fontStyle: 'normal',
                            fontWeight: '600',
                            lineHeight: 'normal',
                        }}
                    >
                        Amount
                    </h1>
                    <input
                        type='number'
                        name='amount'
                        value={amountValue}
                        onChange={handleAmountChange}
                        style={{
                            width: '100%',
                            height: '30px',
                            fontSize: '1.2rem',
                            borderRadius: '10px',
                            border: '1px solid rgba(112, 112, 112, 0.50)',
                        }}
                    />
                </div>
                <textarea
                    name='description'
                    placeholder='Add more details about the refund'
                    value={descriptionValue}
                    onChange={handleDescriptionChange}
                    rows='4'
                    style={{
                        borderRadius: '10px',
                        border: '1px solid rgba(112, 112, 112, 0.50)',
                        width: '100%',
                    }}
                />
                <div style={{ display: 'flex' }}>
                    <div
                        style={{
                            cursor: 'pointer',
                            color: 'white',
                            backgroundColor: 'black',
                            padding: '8px 14px',
                            borderRadius: '8px',
                            fontWeight: '600',
                            border: '1px solid transparent',
                        }}
                        className='saveChangesButton'
                        onClick={onClick}
                    >
                        Refund
                    </div>
                </div>
            </div>
        </div> */}
        </Modal>
    );
};

export default SingleRefundModal;
